import { render, staticRenderFns } from "./EmailRegister.vue?vue&type=template&id=20447ee9&scoped=true&"
import script from "./EmailRegister.vue?vue&type=script&lang=js&"
export * from "./EmailRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20447ee9",
  null
  
)

export default component.exports